import api from './index';
import type { Trip } from './trips';

const API_URL = '/report';

export interface Report {
  id: number;
  trip_id?: number | null;
  reported_by_user_id?: number | null;
  title: string;
  content: string;
  created_at: string;
  updated_at: string;
  trip?: Trip | null;
  reported_by_user?: {
    id: number;
    name: string;
    email: string;
    role: string;
  } | null;
}

export interface CreateReportPayload {
  trip_id: number;
  title: string;
  content: string;
}

export interface UpdateReportPayload {
  title?: string;
  content?: string;
}

const create = async (payload: CreateReportPayload) => {
  const { data } = await api.post<Report>(API_URL, payload);
  return data;
};

const getAll = async () => {
  const { data } = await api.get<Report[]>(API_URL);
  return data;
};

const getByTrip = async (tripId: number) => {
  const { data } = await api.get<Report | null>(`${API_URL}/trip/${tripId}`);
  return data;
};

const update = async (id: number, payload: UpdateReportPayload) => {
  const { data } = await api.patch<Report>(`${API_URL}/${id}`, payload);
  return data;
};

export const reportService = {
  create,
  getAll,
  getByTrip,
  update,
};
